export default __webpack_public_path__ + "static/18-42c84731554625c2d7352821ec3d6803.jpg";